/**
 * 构建属性装饰器工厂
 */
export class PropertyDescriptorFactory {
    storeFactory;
    constructor(storeFactory) {
        this.storeFactory = storeFactory;
    }
    make() {
        return this.descriptor.bind(this);
    }
    /**
     * 装饰器重载
     * @param a
     * @param b
     */
    descriptor(a, b) {
        if (typeof a === 'string') {
            // a=fromKey, b=opts
            return this.storeFactory.make(a, b);
        }
        if (typeof a === 'function') {
            // a=fromFn, b=opts
            return this.storeFactory.make(a, b);
        }
        if (typeof b === 'string') {
            // b=toKey=fromKey
            return this.storeFactory.make(b)(a, b);
        }
    }
}
/**
 * 创建属性装饰器
 * @param storeFactory
 */
export function createPropertyDescriptor(storeFactory) {
    return new PropertyDescriptorFactory(storeFactory).make();
}
